import { Grid } from '@material-ui/core';
import { ContatoForm } from 'app/main/pessoa/Contato';
import React from 'react';

const TabContatoVendedor = () => {
  return (
    <Grid container spacing={3}>
      <ContatoForm />
    </Grid>
  );
};

export default TabContatoVendedor;
